/* G Decor: one-value option pickers.
   1. Product pages: hide pickers that have only one option value (fallback for browsers without :has).
   2. G82 (5 Oct 2026): on every page, including quick-buy pop-ups, tick the only value of a
      one-value option inside a variant picker. The theme hides one-value options, so without
      this a multi-variant product could never finish a selection: the price did not update and
      Add to Bag added nothing. See RESTORE-auto-tick-single-options-G82-2026-10-05.md. */
(function(){
  function hide(){
    if(!document.body.classList.contains('template-product')) return;
    document.querySelectorAll('.option-selector').forEach(function(sel){
      var btns = sel.querySelector('.option-selector__btns');
      if(!btns) return;
      var labels = btns.querySelectorAll('.opt-label, label');
      if(labels.length <= 1){ sel.classList.add('is-single'); }
    });
  }
  function tick(){
    document.querySelectorAll('variant-picker .option-selector[data-selector-type="listed"]').forEach(function(sel){
      var inputs = sel.querySelectorAll('input.js-option');
      if(inputs.length === 1 && !inputs[0].checked){ inputs[0].checked = true; }
    });
  }
  function run(){ hide(); tick(); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', run); } else { run(); }
  var queued = false;
  new MutationObserver(function(){
    if(queued) return;
    queued = true;
    requestAnimationFrame(function(){ queued = false; tick(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
